site.mMenu = {
	init: function() {
		var $mMenu = $('#mainmenu').find('.contentWrap').clone().prop('id', 'mMenu').attr('role','navigation');
		$('body').append($mMenu);
		//var $mHeader = $('#header').clone().prop('id', 'mHeader').addClass('Fixed');
		//$('body').append($mHeader);
		var $mSearch = $('#searchBox .wrap').clone().prop('id','mSearchForm');
		var $qn = $('#qn .wrap').clone().prop('id','mqn');
		var $mContent = $qn.html() + '<div id="mSearchForm">' + $mSearch.html() + '</div>';

		$('#mMenu').mmenu({
			// options
			offCanvas: {
				position: "right"
			},
			extensions: ["theme-moya"],
			navbars: [{
				position: "top",
				content: $mContent
			}]
		},{
			// configuration
			classNames: {
				selected:"active"
			}
		});


		//$('.mm-panel:first-child .mm-navbar','#mMenu').append($mSearch);

		$('#mMenu .mm-next').append('<span class="sr-only">Next</span>');
		$('#mMenu .mm-btn.mm-prev').append('<span class="sr-only">Prev</span>');
		$('#mSearchForm label').remove();
	}
};

site.inits.push('site.mMenu.init()');
